var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _g2, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPitchBearingYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2652_5740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1099,
    cy: 12.4146,
    r: 6.72022,
    stroke: "#E9BA5D",
    strokeWidth: 1.92006,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1091,
    cy: 5.69505,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 10.8281 19.4375)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8513,
    cy: 12.3786,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.39036,
    cy: 12.3786,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.23411,
    cy: 9.08567,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 4.95312 16.0391)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9841,
    cy: 9.08567,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 16.7031 16.0391)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.63255,
    cy: 6.63255,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 7.35156 18.5)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5466,
    cy: 6.63255,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 14.2656 18.5)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2652_5740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1496,
    cy: 12.4465,
    r: 4.60815,
    stroke: "#E9BA5D",
    strokeWidth: 1.53605,
    shapeRendering: "crispEdges"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1404,
    cy: 7.82005,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 10.8594 17.3711)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7263,
    cy: 12.4958,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.51536,
    cy: 12.4958,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.7263,
    cy: 8.49973,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 8.44531 16.6953)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.04661,
    cy: 10.2654,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 6.76562 14.9219)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2654,
    cy: 10.2654,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 14.9844 14.9219)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7341,
    cy: 8.57395,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 13.4531 16.6211)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5143 0.356315L13.8726 2.71454C14.1916 3.03355 13.9656 3.57902 13.5145 3.57902L8.79802 3.57902C8.34687 3.57902 8.12093 3.03356 8.43995 2.71454L10.7982 0.356315C10.9959 0.158554 11.3166 0.158554 11.5143 0.356315Z",
    fill: "#E9BA5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6792 18.6301L18.5078 19.662C18.0788 19.8016 17.6952 19.3528 17.8998 18.9508L20.0393 14.7475C20.2439 14.3454 20.8325 14.3915 20.9721 14.8205L22.004 17.9919C22.0906 18.2578 21.9451 18.5436 21.6792 18.6301Z",
    fill: "#E9BA5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.166903 17.7064L1.26592 14.5577C1.41459 14.1317 2.00404 14.0982 2.20011 14.5045L4.24984 18.7523C4.44591 19.1586 4.05284 19.5991 3.62689 19.4504L0.478139 18.3514C0.214084 18.2593 0.0747391 17.9705 0.166903 17.7064Z",
    fill: "#E9BA5D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2652_5740",
    x: 0.357588,
    y: 4.73438,
    width: 21.5036,
    height: 21.5036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.0721
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53605
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2652_5740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2652_5740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2652_5740",
    x: 2.70134,
    y: 7.07031,
    width: 16.8942,
    height: 16.8981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.0721
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53605
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2652_5740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2652_5740",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchBearingYellow);
export default __webpack_public_path__ + "static/media/Pitch_Bearing_Yellow.c93629ea1ad397bd20b444884f03e373.svg";
export { ForwardRef as ReactComponent };